import React from 'react';
export function IntroSection() {
  return <section className="py-16 md:py-20 bg-brand-black" data-id="element-826">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-827">
        <p className="text-xl text-brand-gray-300 leading-relaxed" data-id="element-828">
          Welcome to our Training & Service Partner and Resource page. In this
          section you will have the ability to visit our other affiliated
          members websites. We thank them and rely on their support for better,
          training and security for our families, businesses and our nation.
        </p>
      </div>
    </section>;
}